<div class="inner-detalhes">
  <app-icone-descricao
    [Icone]="'fas fa-warehouse'"
    [Titulo]="tipo"
    [Descricao]="razaoSocial"
  >
  </app-icone-descricao>
  <div class="info-group">
    <span>Endereço:</span>
    <p>{{ endereco }}</p>
  </div>
  <div class="inline-items">
    <div class="info-group">
      <span>Inscrição Estadual:</span>
      <p>{{ remInscEstadual ? remInscEstadual : "Sem informação" }}</p>
    </div>
    <div class="info-group">
      <span>Bairro:</span>
      <p>{{ bairro }}</p>
    </div>
    <div class="info-group">
      <span>Cidade:</span>
      <p>{{ cidade }}</p>
    </div>
  </div>
  <div class="inline-items">
    <div class="info-group">
      <span>UF:</span>
      <p>{{ uf }}</p>
    </div>
    <div class="info-group">
      <span>CEP:</span>
      <p>{{ cep }}</p>
    </div>
    <div class="info-group">
      <span>CNPJ:</span>
      <p>{{ cgc ? cgc : "Sem informação" }}</p>
    </div>
  </div>
</div>
